import api from './api';

export const notificationService = {
  async getAll(page = 1) {
    const response = await api.get('/notifications', { params: { page } });
    return response.data;
  },

  async getUnreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  async markAsRead(notificationId) {
    const response = await api.post(`/notifications/${notificationId}/read`);
    return response.data;
  },

  async markAllAsRead() {
    const response = await api.post('/notifications/mark-all-read');
    return response.data;
  },

  async delete(notificationId) {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  },
};
